<template>
  <div class="flex flex-col max-w-7xl mx-auto my-10">
    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <div v-if="isLoading">
        <Spinner />
      </div>
      <div class="flex my-2 justify-between items-center">
        <div class="text-gray-400 italic font-thin text-sm">
          Note: Abandoned carts without phone number are automatically hidden.
        </div>
        <div>
          <button
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150 mr-2"
            @click="openTemplates"
          >
            Templates
          </button>
          <button
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150"
            @click="refreshCurrentPage"
            :disabled="isLoading"
          >
            Refresh<span v-if="isLoading">ing</span>
          </button>
        </div>
      </div>
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
        >
          <ManualMessageAlert />
          <div
            v-if="checkouts.docs && checkouts.docs.length > 0"
            class="align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-8"
          >
            <table class="min-w-full">
              <thead>
                <tr class="hidden md:table-row">
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Customer
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Date
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Recovery Status
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Message Status
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Checkout id
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Total & last order date
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Tags
                  </th>
                  <th
                    class="px-3 py-3 border-b border-gray-200 bg-gray-50"
                  ></th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <CartListItem
                  v-for="checkout in checkouts.docs"
                  :key="checkout.id"
                  :checkout="checkout"
                  @refreshCurrentPage="refreshCurrentPage"
                />
              </tbody>
            </table>
            <Pagination :page="checkouts" @pageChanged="loadPage" />
          </div>
          <div
            class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
            v-if="!isLoading && checkouts.docs && checkouts.docs.length === 0"
          >
            You don't have any abandoned carts right now. We will be listing
            them here as soon a cart is abandoned.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import CartListItem from "./CartListItem";
import Pagination from "./Pagination";
import ManualMessageAlert from "./ManualMessageAlert";

export default {
  name: "AbadonedCartList",
  data() {
    return {
      isLoading: false
    };
  },
  components: {
    CartListItem,
    Pagination,
    Spinner,
    ManualMessageAlert
  },
  computed: {
    checkouts() {
      return this.$store.getters.getCheckouts;
    },
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getTemplates");
    this.$store.dispatch("getConfig");
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("getAbadonedCarts", { page });
      this.isLoading = false;
    },
    refreshCurrentPage() {
      const page = this.checkouts.page;
      this.loadPage(page);
    },
    openTemplates() {
      this.$router.push({ name: "Templates" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
